import Project from "../Project";

const ProjectsSection = ({ defaultVisibility }) => (
  <div id="projects" className={`${defaultVisibility}`}>
    <h1 className="py-10 leading-[4rem] font-bold text-left md:pl-10 pl-5 text-3xl text-black">
      <div className="before:block before:absolute before:-inset-0 before:bg-teal relative">
        <span className="z-10 relative font-bold px-5">Projects</span>
      </div>
    </h1>
    <div className="grid grid-cols-1 md:grid-cols-1 gap-0 md:px-10 px-5">
      <Project
        Name={"Beautiful OTP"}
        Description={
          "Free, secure and open source iOS app for managing 2-step verification tokens."
        }
        Image={"project_logos/BeautifulOTP.png"}
        Technologies={"Flutter, Dart"}
        Platforms={"iOS"}
        Link={"https://github.com/ohIcee/beautiful_otp"}
      />
      <Project
        Name={"ShopTogether"}
        Description={"Share shopping lists with your friends and family."}
        Image={"project_logos/shoptogether_icon.png"}
        Technologies={"Flutter, Dart, Firebase"}
        Platforms={"Android, iOS"}
        Link={
          "https://play.google.com/store/apps/details?id=com.potatocouch.shoptogether"
        }
      />
      <Project
        Name={"FaceIt Stats"}
        Description={
          "Mobile Application for looking up player statistics for the popular gaming platform faceit."
        }
        Image={"project_logos/FS_ICON.png"}
        Technologies={"Flutter, Dart"}
        Platforms={"Android"}
        Link={
          "https://play.google.com/store/apps/details?id=com.potatocouch.faceit_stats"
        }
      />
      <Project
        Name={"Nomago Vozni Redi (Bolsago)"}
        Description={
          "View Nomago bus departure and arrival times in a prettier and more responsive interface."
        }
        Image={"project_logos/bolsago.png"}
        Technologies={"Flutter, Dart"}
        Platforms={"Android"}
      />
      <Project
        Name={"Stin"}
        Description={"Website for the company Stin"}
        Image={"project_logos/stin.png"}
        Technologies={"HTML, CSS, JavaScript"}
        Platforms={"Web"}
        Link={"https://www.stin.si/"}
      />
      <Project
        Name={"NetYeet"}
        Description={
          "Social network made as my graduation project. It features creating accounts, posting, editing profile, following users, home feed, searching for users and more."
        }
        Technologies={"HTML, CSS, JavaScript, PHP"}
        Platforms={"Web"}
        Link={"https://github.com/ohIcee/NetYeet"}
      />
    </div>
  </div>
);

export default ProjectsSection;
